// extracted by mini-css-extract-plugin
export var addDetails = "_0-l";
export var addEditButton = "_0-b";
export var addressFields = "_0-2";
export var animationContainer = "_0-0";
export var closeButton = "_0-p";
export var customerDetails = "_0-x";
export var customerInformationWrapper = "_0-6";
export var dropdowns = "_0-4";
export var error = "_0-k";
export var fields = "_0-n";
export var flex = "_0-m";
export var grow = "_0-3";
export var icon = "_0-d";
export var imageButton = "_0-q";
export var imagesWrapper = "_0-s";
export var itemDetails = "_0-i";
export var itemSelectionHeader = "_0-9";
export var label = "_0-w";
export var lineItemImage = "_0-j";
export var lineItemReturnedWrapper = "_0-h";
export var lineItemWrapper = "_0-g";
export var modalContent = "_0-f";
export var modalFooter = "_0-1";
export var multipleChoiceAnswer = "_0-u";
export var multipleChoiceAnswersWrapper = "_0-t";
export var orderButton = "_0-z";
export var orderLabel = "_0-10";
export var orderSelection = "_0-y";
export var question = "_0-v";
export var search = "_0-e";
export var selectCheckbox = "_0-a";
export var selectionWrapper = "_0-8";
export var spinner = "_0-c";
export var subheader = "_0-5";
export var title = "_0-7";
export var uploadedImage = "_0-o";
export var uploadedImageWrapper = "_0-r";